module.exports = __webpack_public_path__ + "static/media/at.8b1280a5.svg";